import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { humanLength } from 'handimap-react-lib/utils/utils';

export const DistanceBadge = ({length}) => {
  const styles = {
    container : {
      display: 'flex',
      paddingX: '1em',
      paddingY: '.4em',
      backgroundColor: '#000000',
      alignItems: 'center',
      justifyContent: 'center',
    },
    label: {
      color: '#FFFFFF',
      fontSize: '1em'
    }
  };
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.label}>
        {humanLength(length)}
      </Typography>
    </Box>
  );
};